export const sxStyle = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    backgroundColor: 'transparent',
  },

  lineSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    mx: 0,
    minHeight: 40,
  },

  scalesText: {
    fontWeight: 600,
    color: '#000',
    fontSize: '14px',
    lineHeight: 1.5,
    textAlign: 'center',
  },

  dashedLine: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    zIndex: 1,
  },

  pointsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 3,
    flexDirection: 'column',
    position: 'relative',
    top: '-9px',
  },

  point: (isStop, color) => ({
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: isStop ? '#fff' : color,
    border: '1px solid black',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    marginTop: '-1px',
    mx: '5px',
  }),
};
